import React, { useEffect, useState } from 'react';
import Header from '../../components/common/global-top-bar';

import { CustomInput } from '../../components/common';

import { HeaderOptions } from './clients-constants';
import RewardGiftCard from './packages/reward-gift-card';
import ConsumerSubscriptionModel from './packages/consumer-subsription-model';
import Promotion from './packages/promotion';
import CheckIns from './packages/check-ins';
import RewardsPTO from './packages/reward-pto';
import HeadBack from './redirect';
import CappedAccess from './packages/capped-access';
import UnlimitedAccess from './packages/unlimited-access';
import Discount from './packages/discount';
import PackageDetails from './packages/package-details';
import Spinner from '../../components/common/spinner';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import Modal from '../../components/common/modal';
import RouteLeavingGuard from '../../components/route-leaving-prompt';
import { ROUTE_PATH } from '../../routes/paths';
import Dependents from './packages/dependents';
import EligibilityConfiguration from './packages/eligibility-configuration';
import RichTextEditor from '../../components/rich-text-editor/rich-text-editor';
import MemberPay from './packages/member-pay';
import {
  useIncentiveOrganizations,
  useProductTemplates,
  useClient,
  useDeletePackage,
  useCreatePackage,
  Package,
  ProductTemplate,
  ProductTemplateKey,
} from '../../hooks/useClients';
import { useEmailTemplateMetadata, useSystemMessages } from '../../hooks/useComms';

interface header {
  path: string;
  heading: string;
}

interface ApiError {
  status: number;
  data: {
    description: string;
  };
}

const Packages: React.FunctionComponent = (): JSX.Element => {
  const clientId = localStorage.getItem('clientid');
  const { data: client, isLoading: clientLoading, error: clientError } = useClient(Number(clientId!));
  const { data: productTemplates } = useProductTemplates();
  const { data: emailTemplates } = useEmailTemplateMetadata();
  const { data: incentiveOrganizations } = useIncentiveOrganizations();
  const { data: systemMessages } = useSystemMessages();
  const { deletePackage } = useDeletePackage(Number(clientId!));
  const { createPackage } = useCreatePackage(Number(clientId!));
  const history = useHistory();

  const [packageName, setPackageName] = useState('');
  const [packageCode, setPackageCode] = useState('');
  const [benefitsDescription, setBenefitsDescription] = useState<any>();
  const [addNewClientToggle, setAddNewClientToggle] = useState(false);
  const [saveDataModal, setSaveDataModal] = useState(false);
  const [error, setError] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [packageData, setPackageData] = useState<Package>();

  const Validation = () => {
    if (!packageName || !packageCode) {
      setError(true);
      return false;
    }
    setError(false);
    return true;
  };

  const handleDeletePlan = () => {
    deletePackage.mutate({ packageId: packageData?.id!, packageName: packageData?.name! });
    setIsDelete(!isDelete);
  };

  const handleDeletePlanModel = (data: Package) => {
    setPackageData(data);
    setIsDelete(!isDelete);
  };

  useEffect(() => {
    if (clientError) {
      const error = clientError as ApiError;
      if (error.status === 400 && error?.data?.description) {
        toast.error(error.data.description);
      }
    }
  }, [clientError]);

  const handleSave = () => {
    const payload: Partial<Package> = {
      benefits_description: benefitsDescription,
      code: packageCode?.trim(),
      name: packageName?.trim(),
      dependents_configuration: {
        enabled: false,
        dependent_count: 3,
        members_can_add_dependents: true,
      },
    };
    if (clientId) {
      if (Validation()) {
        createPackage.mutate(payload);
      }
    } else {
      toast.error('Please create a client Before creating a package');
    }
  };

  const sorting = (pre: Package, next: Package) => {
    return pre.id! - next.id!;
  };

  const findTemplate = (option: ProductTemplateKey) => {
    const template = productTemplates?.find((item: ProductTemplate) => item.key === option);
    return template;
  };

  const clearfields = () => {
    setPackageCode('');
    setPackageName('');
    setBenefitsDescription('');
    setError(false);
  };

  useEffect(() => {
    if (client && client?.packages.length < 1) {
      setAddNewClientToggle(true);
    } else {
      setAddNewClientToggle(false);
    }
  }, [client]);

  return (
    <>
      <RouteLeavingGuard
        when={saveDataModal}
        navigate={(path: string) => history.push(path)}
        shouldBlockNavigation={(location: any) => {
          if (location.pathname !== ROUTE_PATH.GROUPS_PACKAGES) {
            return true;
          }
          return false;
        }}
        titleText={'Alert'}
        contentText={'You have unsaved changes. Do you want to leave this page and lose your changes?'}
        cancelButtonText={'Cancel'}
        confirmButtonText={'Disregard changes'}
      />
      {clientLoading && <Spinner />}
      <Header heading={<HeadBack clientName={client?.name || ''} />} />

      <SwitchBar
        heading={HeaderOptions}
        position={2}
        isDisabled={clientId ? false : true}
        optionalButton={
          <div className="w-1/12">
            <div className="w-full">
              <button
                className="stacked-bar-blue-400 h-6 w-full rounded-full px-2 text-center text-sm text-white"
                onClick={() => {
                  if (!addNewClientToggle) {
                    clearfields();
                    setAddNewClientToggle(true);
                  } else if (clientId) {
                    handleSave();
                  }
                }}
                data-testid={!addNewClientToggle ? 'client-package-add-button' : 'client-package-save-button'}
              >
                {!addNewClientToggle ? 'ADD' : clientId && 'SAVE'}
              </button>
            </div>
          </div>
        }
      />
      <Modal
        isModel={isDelete}
        InnerComponent={
          <div className="inline-block transform overflow-hidden rounded-lg bg-white text-left align-bottom shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:align-middle">
            <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
              <div className="sm:flex sm:items-start">
                <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                  <h3 className="text-lg font-medium leading-6 text-gray-900" id="modal-title">
                    Alert
                  </h3>
                  <div className="mt-2 flex">
                    <p className="flex items-center text-sm text-gray-500">
                      Are you sure you want to remove this {packageData?.name}?
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
              <button
                type="button"
                onClick={handleDeletePlan}
                className="stacked-bar-blue-400 inline-flex w-full justify-center rounded-md border border-transparent px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm"
                data-testid="delete-plan-button"
              >
                Remove
              </button>
              <button
                type="button"
                className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:ml-3 sm:mt-0 sm:w-auto sm:text-sm"
                onClick={() => {
                  setIsDelete(false);
                }}
                data-testid="cancel-delete-plan-button"
              >
                Cancel
              </button>
            </div>
          </div>
        }
      ></Modal>
      <div className="max-window-height overflow-y-auto px-7 pb-32 pt-7">
        {client &&
        client?.packages.length > 0 &&
        !addNewClientToggle &&
        clientId &&
        productTemplates &&
        productTemplates?.length > 0 ? (
          client.packages.sort(sorting).map((item: Package) => {
            return (
              <div className="pb-12">
                <div className="flex h-10 w-full items-center justify-between bg-black">
                  <div className="flex">
                    <div className="px-2 text-white">{item.name}</div>
                    <div className="px-4 font-bold text-white">{item.code}</div>
                  </div>
                  <div>
                    <div className="w-full pr-2">
                      <button
                        className="h-6 w-full rounded-full bg-gray-300 px-7 text-center text-sm text-white"
                        onClick={() => handleDeletePlanModel(item)}
                        data-testid="open-delete-plan-modal"
                      >
                        REMOVE
                      </button>
                    </div>
                    {/* <div className="w-full pr-2">
                                        <button className="bg-gray-dark rounded-full w-full text-center h-6 text-sm text-white px-7">
                                            CREATE TEMPLATE
                                        </button>
                                    </div> */}
                  </div>
                </div>
                <PackageDetails packageData={item} setSaveDataModal={setSaveDataModal} />
                <EligibilityConfiguration
                  packageData={item}
                  defaultPackage={client?.eligibility_config?.default_package!}
                  setSaveDataModal={setSaveDataModal}
                />
                <MemberPay packageData={item} />
                <Dependents packageData={item} setSaveDataModal={setSaveDataModal} />
                <CappedAccess
                  packageData={item}
                  defaultTemplate={findTemplate(ProductTemplateKey.CAPPED_ACCESS)!}
                  setSaveDataModal={setSaveDataModal}
                />
                <CheckIns
                  packageData={item}
                  defaultTemplate={findTemplate(ProductTemplateKey.CHECKIN_WITH_INTERIM)!}
                  systemMessages={systemMessages || []}
                  setSaveDataModal={setSaveDataModal}
                />
                <RewardGiftCard
                  packageData={item}
                  defaultTemplate={findTemplate(ProductTemplateKey.REWARD_GIFT_CARD)!}
                  setSaveDataModal={setSaveDataModal}
                  incentives={incentiveOrganizations!}
                />
                <Discount
                  packageData={item}
                  defaultTemplate={findTemplate(ProductTemplateKey.DISCOUNT)!}
                  setSaveDataModal={setSaveDataModal}
                />
                <UnlimitedAccess
                  packageData={item}
                  defaultTemplate={findTemplate(ProductTemplateKey.UNLIMITED_ACCESS)!}
                  setSaveDataModal={setSaveDataModal}
                />

                <RewardsPTO
                  packageData={item}
                  defaultTemplate={findTemplate(ProductTemplateKey.REWARD_PTO)!}
                  setSaveDataModal={setSaveDataModal}
                />
                <ConsumerSubscriptionModel
                  packageData={item}
                  defaultTemplate={findTemplate(ProductTemplateKey.SUBSCRIPTION)!}
                  setSaveDataModal={setSaveDataModal}
                  emailTemplates={emailTemplates}
                />
                <Promotion packageData={item} setSaveDataModal={setSaveDataModal} />
              </div>
            );
          })
        ) : clientId && addNewClientToggle ? (
          <>
            <div className="text-gray-dark gray-border-line mb-2 flex h-10 w-full items-center justify-between border-b bg-transparent px-2 text-sm font-bold">
              PLAN CONFIGURATION
            </div>
            <div className="my-10 flex justify-evenly gap-7">
              <div className="w-full py-4">
                <CustomInput
                  inputType={'text'}
                  value={packageName}
                  setValue={setPackageName}
                  Label={'Plan Name'}
                  Error={error && !packageName}
                  ErrorMessage={'Field is Required'}
                  dataTestId="plan-name"
                />
              </div>
              <div className="w-full py-4">
                <CustomInput
                  inputType={'text'}
                  value={packageCode}
                  setValue={setPackageCode}
                  Label={'Plan Code'}
                  Error={error && !packageCode}
                  ErrorMessage={'Field is Required'}
                  dataTestId="plan-code"
                />
              </div>
            </div>
            <div className="my-10 flex justify-evenly gap-7">
              <div className="w-full py-4">
                <label className="text-dark-blue mb-2 block font-medium leading-4">Benefits Description</label>
                <RichTextEditor
                  content={benefitsDescription}
                  onChange={(value) => {
                    setBenefitsDescription(value);
                  }}
                  key={`benefits-description-${clientId}`}
                  data-testid="benefits-description-editor"
                />
              </div>
            </div>
            <button
              className={'stacked-bar-blue-400 disabled: rounded-sm px-4 py-2 text-center text-sm text-white'}
              onClick={() => {
                setAddNewClientToggle(false);
                clearfields();
              }}
            >
              CANCEL
            </button>
          </>
        ) : (
          !clientLoading &&
          !clientId &&
          !addNewClientToggle && (
            <p className="font-4xl text-2xl font-extrabold leading-4">
              No Client id Found , Please create the Client in order to create a plan
            </p>
          )
        )}
      </div>
    </>
  );
};

type SwitchBarprops = {
  heading: header[];
  position: number;
  optionalButton?: React.ReactNode;
  isDisabled?: any;
};

const SwitchBar: React.FunctionComponent<SwitchBarprops> = ({
  heading,
  position,
  optionalButton,
  isDisabled,
}): JSX.Element => {
  const history = useHistory();
  return (
    <div className="gray-border-line bg-gray-background-light flex h-10 w-full items-center justify-between border-b px-4">
      <div className="gray-background-dark flex h-full items-center justify-center">
        {heading.map((item: header, index: number) => (
          <button
            className={
              'px-5 py-2 text-sm ' +
              (index === position ? ' bg-blue-primary h-full font-bold text-white' : ' text-gray-dark h-full')
            }
            onClick={() => {
              history.push(item.path.toString());
            }}
            disabled={isDisabled}
            data-testid={`header-tab-${item.heading}`}
          >
            {item.heading}
          </button>
        ))}
      </div>
      {optionalButton}
    </div>
  );
};

export default Packages;
